var content = require("!!../../../css-loader/dist/cjs.js??ref--5-oneOf-3-1!../../../postcss-loader/src/index.js??postcss!./image-gallery.css");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {"injectType":"singletonStyleTag"}

options.insert = function (element) {
            const parent = document.querySelector('family-assets-chat');
            parent.appendChild(element);
          };
options.singleton = true;

var update = require("!../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
